export function normalizeTotalPages(value) {
  const total = Number(value)
  return Number.isFinite(total) && total > 0 ? Math.floor(total) : 1
}

export function normalizeCurrentPage(value, totalPages) {
  const total = normalizeTotalPages(totalPages)
  const page = Number(value)
  if (!Number.isFinite(page) || page < 1) return 1
  return Math.min(Math.floor(page), total)
}

export function paginationItems(totalPages, currentPage) {
  const total = normalizeTotalPages(totalPages)
  const current = normalizeCurrentPage(currentPage, total)
  if (total <= 7) {
    return Array.from({ length: total }, (_, index) => ({ type: 'page', page: index + 1 }))
  }

  if (current <= 4) {
    return [1, 2, 3, 4, 5].map((page) => ({ type: 'page', page })).concat([
      { type: 'ellipsis', direction: 'forward', page: Math.min(total, current + 5) },
      { type: 'page', page: total },
    ])
  }

  if (current >= total - 3) {
    return [
      { type: 'page', page: 1 },
      { type: 'ellipsis', direction: 'backward', page: Math.max(1, current - 5) },
      ...Array.from({ length: 5 }, (_, index) => ({ type: 'page', page: total - 4 + index })),
    ]
  }

  const items = [{ type: 'page', page: 1 }]
  const left = Math.max(current - 1, 2)
  const right = Math.min(current + 1, total - 1)

  if (left > 3) items.push({ type: 'ellipsis', direction: 'backward', page: Math.max(1, current - 5) })
  else for (let page = 2; page < left; page += 1) items.push({ type: 'page', page })

  for (let page = left; page <= right; page += 1) items.push({ type: 'page', page })

  if (right < total - 2) items.push({ type: 'ellipsis', direction: 'forward', page: Math.min(total, current + 5) })
  else for (let page = right + 1; page < total; page += 1) items.push({ type: 'page', page })

  items.push({ type: 'page', page: total })
  return items
}
